import React from 'react';
import {
  Redirect,
  Route,
  Switch,
  useParams,
  useRouteMatch,
} from 'react-router-dom';
import OrgSnapshotSetDetailContainer from '../../containers/OrgSnapshotSetDetailContainer';
import OrgSnapshotCreateContainer from '../../containers/OrgSnapshotCreateContainer';
import OrgSnapshotReports from './OrgSnapshotReports';

const SNAPSHOT_ID =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

export default function OrgSnapshotsRouter() {
  const match = useRouteMatch();
  const { workspaceId, orgId } = useParams();
  const orgTo = `/w/${workspaceId}/orgs/${orgId}`;
  const setPath = `${match.path}/:sourceType(assessment|rubric)/:sourceKey`;

  return (
    <Switch>
      <Route exact path={match.path}>
        <Redirect to={orgTo} />
      </Route>
      <Route
        exact
        path={`${setPath}/new`}
        component={OrgSnapshotCreateContainer}
      />
      <Route
        path={`${setPath}/:snapshotId(${SNAPSHOT_ID})`}
        component={OrgSnapshotReports}
      />
      <Route path={setPath} component={OrgSnapshotSetDetailContainer} />
      <Redirect to={orgTo} />
    </Switch>
  );
}
